module.exports = __webpack_public_path__ + "static/pride-222efd1916aa44c797c0c350dfcc02d6.png";